
  document.addEventListener('DOMContentLoaded', function() {
      const all_media_items = document.querySelectorAll('.product__media-item');
      let selected_val = document.querySelector('.selected_color_val');

      function showMatchingImageByTitle(title) {
          all_media_items.forEach(mediaItem => {
              const img = mediaItem.querySelector('img');
              if (img.alt === title) {
                  mediaItem.style.display = 'block';
              } else {
                  mediaItem.style.display = 'none';
              }
          });
      }

      function showMatchingImage() {
        if (!selected_val) return;
        const selectedTitle = selected_val.textContent.trim();
        showMatchingImageByTitle(selectedTitle);
      }

      showMatchingImage();

      document.addEventListener('click', (e) => {
          const target = e.target.closest('.custom-swatch-input');
          if (target) {
            const isSizeChecked = Array.from(document.querySelectorAll('.input_size'))
                                      .some(checkbox => checkbox.checked);
            if (isSizeChecked) {
                const labelTitle = target.getAttribute('title');
                showMatchingImageByTitle(labelTitle);
            } else {
                console.log('Please select a size before changing the color.');
            }
          }
      });
  }); 